import { getType } from "typesafe-actions";
import BASE_URL from "../../config";
import * as backendAddress from "./actions";
export var initialState = BASE_URL;
export var backendAddressReducer = function backendAddressReducer(state, action) {
  if (state === void 0) {
    state = initialState;
  }

  switch (action.type) {
    case getType(backendAddress.clear):
      return initialState;

    case getType(backendAddress.set):
      return action.payload;

    default:
      return state;
  }
};